((Drupal, once, Swiper) => {
  /**
   * The current carousel ID.
   *
   * @type {number}
   */
  let id = 1;

  /**
   * The mobile breakpoint.
   *
   * @type {MediaQueryList}
   */
  const desktopBreakpoint = window.matchMedia("(min-width: 1200px)");

  function shouldUseNavigation(element, numberOfSlides) {
    let nav = true;
    // Count the number of .ixm-card-item elements and only enable the carousel if there are more than 4 for desktop.
    const cardItems = element.querySelectorAll(".ixm-card-item");
    if (desktopBreakpoint.matches && cardItems.length <= numberOfSlides) {
      nav = false;
    }
    return nav;
  }

  /**
   * Instantiate carousel with Swiper.
   */
  Drupal.behaviors.tfalCarousel = {
    attach: function attach(context) {
      once("carousel", ".carousel-mobile-only", context).forEach((element) => {
        element.id = `swiper-${id}`;
        element.classList.add("swiper");

        // Get number of slides from data attribute.
        const numberOfSlides = element.dataset.slideItems
          ? element.dataset.slideItems
          : 4;

        element
          .querySelector(".view-content, .ixm-card-wrapper")
          .classList.add("swiper-wrapper");
        element
          .querySelectorAll(".views-row, .ixm-card-item")
          .forEach((item) => item.classList.add("swiper-slide"));

        // Count the number of slides and only enable the carousel if there
        // are more than 4 for desktop.
        this.enable(element, numberOfSlides);

        id += 1;
      });
    },
    enable: function enable(element, numberOfSlides) {
      element.swiperNavigation = document.createElement("div");
      element.swiperNavigation.className = "swiper-navigation";
      element.appendChild(element.swiperNavigation);
      const pagination = document.createElement("div");
      pagination.id = `swiper-pagination-${id}`;
      element.swiperNavigation.appendChild(pagination);
      const prev = document.createElement("button");
      prev.id = `swiper-button-${id}-prev`;
      prev.className = "carousel-control-prev-icon";
      element.swiperNavigation.appendChild(prev);
      const next = document.createElement("button");
      next.id = `swiper-button-${id}-next`;
      next.className = "carousel-control-next-icon";
      element.swiperNavigation.appendChild(next);

      element.swiper = new Swiper(`#${element.id}`, {
        slidesPerView: 1,
        spaceBetween: 24,
        loop: !desktopBreakpoint.matches,
        keyboard: {
          enabled: true,
        },
        navigation: {
          nextEl: `#swiper-button-${id}-next`,
          prevEl: `#swiper-button-${id}-prev`,
        },
        pagination: {
          el: `#swiper-pagination-${id}`,
          clickable: true,
        },
        breakpoints: {
          1200: {
            slidesPerView: numberOfSlides,
          },
        },
        on: {
          resize(swiper) {
            // Togle the visibility of the navigation based on the number of slides and the breakpoint.
            if (shouldUseNavigation(element, numberOfSlides)) {
              element.classList.add("swiper-navigation--visible");
              element.classList.remove("swiper-navigation--hidden");
            } else {
              element.classList.add("swiper-navigation--hidden");
              element.classList.remove("swiper-navigation--visible");
            }

            swiper.update();
          },
        },
      });
    },
  };
})(Drupal, once, Swiper);
